























































import Component from "vue-class-component";
import BaseComponent from "@/asdcom/BaseComponent";
import { Prop } from "vue-property-decorator";
import { AttachmentDto } from "@/asdcom/apiproxy/apiproxy.dto";

@Component
export default class AttachmentsComponent extends BaseComponent {
  previewImage: string = "";
  showAttachmentPreview: boolean = false;

  @Prop({
    default: () => {
      return [];
    }
  })
  viewModel?: AttachmentDto[];


  previewAttachment(id: string) {
    this.attachPreviewDialogVisible(true);
    // abp.log.debug({ "attachments-component previewAttachment": id });
    this.$appsvs.vcpOnlineOk
      .retrieveAttachmentPreview(id)
      .then((res: string) => {
        this.previewImage = `data:image/jpeg;base64,${res}`;
      });
  }

  attachPreviewDialogVisible(isVisible: boolean) {
    this.showAttachmentPreview = isVisible;
    if (!isVisible) {
      this.previewImage = "";
    }
  }
}
